import { render, staticRenderFns } from "./TextWrapper.vue?vue&type=template&id=33b8cc3d"
import script from "./TextWrapper.vue?vue&type=script&lang=js"
export * from "./TextWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports